import {
  FEEDBACK_COMPLETED_STATUS,
  type FeedbackCompletion,
} from '../constants/feedback.constants';
import type { FeedbackStatus } from '../types/feedback.types';

export const isFeedbackCompleted = (status: FeedbackStatus): boolean =>
  status === FEEDBACK_COMPLETED_STATUS;

export const getFeedbackCompletion = (status: FeedbackStatus): FeedbackCompletion =>
  isFeedbackCompleted(status) ? 'completed' : 'notComplete';
